/**
 * Utility helpers for interpreting GraphQL / AppSync error responses.
 */

/** Extract the first meaningful error message from a GraphQL error payload. */
export const getGraphQlErrorMessage = (err: unknown): string => {
    const graphQlMessage = (err as { errors?: Array<{ message?: string }> })?.errors?.[0]?.message;
    if (graphQlMessage) return graphQlMessage;
    if (err instanceof Error) return err.message;
    return String(err ?? '');
};

/** AppSync update/create conditions map to DynamoDB ConditionalCheckFailedException. */
export const isConditionalRequestFailure = (err: unknown): boolean =>
    /conditional request failed/i.test(getGraphQlErrorMessage(err));
